// extracted by mini-css-extract-plugin
module.exports = {"tertiary":"headingpair_tertiary__pJiyt","center":"headingpair_center__FcXii","moreMargin":"headingpair_moreMargin__c3_gT"};